"use client";

import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetYourQuoteCTA() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    number: "8+",
    label: "Years active"
  }, {
    number: "4,617",
    label: "Projects completed"
  }, {
    number: "24/7",
    label: "Support"
  }];
  return <section data-section-id="2182" id="getyourquotecta" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-[140px] px-6 md:px-10 lg:px-16">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} data-index={0} className="lg:col-span-7 transition-all duration-[800ms] ease-out" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateY(0)" : "translateY(24px)"
        }}>
            <p className="font-mono text-xs md:text-sm uppercase tracking-[0.25em] mb-8 text-primary">
              Start your project
            </p>

            <h2 className="font-serif font-light leading-[1.05] mb-10 text-4xl md:text-5xl lg:text-6xl xl:text-[72px] text-foreground">
              Expert pool design
              <br />
              built for your
              <br />
              <em className="italic font-light text-primary">
                lifestyle.
              </em>
            </h2>

            <p className="font-default text-base md:text-lg leading-relaxed max-w-[480px] mb-10 text-muted-foreground">
              Rocket City Water Wizards delivers precision pool installations and maintenance. From custom backyard renovations to reliable seasonal service, we ensure your water is always perfect.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 sm:items-center">
              <Button asChild size="lg" className="font-default text-base px-8 h-12 rounded-none shadow-md hover:shadow-lg transition-shadow bg-primary text-primary-foreground">
                <Link to="/InstallationsPage">Request a Quote</Link>
              </Button>

              <Link to="/ServiceRepairPage" className="inline-flex items-center gap-2 font-default text-base group text-primary">
                <span className="border-b pb-1 transition-colors border-primary">
                  View Our Services
                </span>
                <ArrowUpRight className="size-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative">
            <div ref={imageRef} data-index={1} className="relative transition-all duration-[800ms] ease-out" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateY(0)" : "translateY(24px)"
          }}>
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-none" style={{
              boxShadow: "inset 0 0 0 1px hsl(191 91% 47% / 0.4)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1752522/img/modern_pool_installation.png" alt="A sleek modern swimming pool installation in a residential backyard" loading="lazy" decoding="async" className="w-full h-full object-cover" />
                <div aria-hidden="true" className="absolute inset-0 rounded-none pointer-events-none" style={{
                boxShadow: "inset 0 0 0 1px hsl(191 91% 47% / 0.5)"
              }} />
              </div>

              {}
              <Card ref={cardRef} className="absolute -bottom-10 -left-4 sm:-left-10 w-[78%] sm:w-[280px] p-7 rounded-none shadow-2xl transition-all duration-[800ms] ease-out bg-card text-card-foreground" style={{
              transitionDelay: "400ms",
              opacity: cardVisible ? 1 : 0,
              transform: cardVisible ? "translateY(0)" : "translateY(24px)"
            }}>
                <div className="flex flex-col gap-5">
                  {stats.map((stat, i) => <div key={i} data-index={i} className={i < stats.length - 1 ? "pb-5 border-b border-border" : ""}>
                      <div className="font-serif font-light text-4xl leading-none mb-2 text-foreground">
                        {stat.number}
                      </div>
                      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                        {stat.label}
                      </div>
                    </div>)}
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}